import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function TrendingSection() {
  const trending = articles.filter((a) => a.trending).slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6 md:mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的内容</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {trending.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}